import React from 'react';
import { Heart } from 'lucide-react';

const EN_COURS_IMG = 'https://images.unsplash.com/photo-1507539989371-99615e449486?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600';

const VoyageEnCours = () => {
  return (
    <section id="en-cours" data-testid="voyage-en-cours-section" className="relative py-28 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${EN_COURS_IMG})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/85 via-charcoal/70 to-charcoal/90"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-cream-100">
        <div
          data-testid="en-cours-badge"
          className="inline-flex items-center gap-3 mb-8 px-6 py-2.5 bg-gold-500/20 backdrop-blur-md border border-gold-300/40 rounded-full"
        >
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold-300 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-gold-300"></span>
          </span>
          <span className="text-sm tracking-[0.25em] text-gold-200 uppercase">Voyage en cours</span>
        </div>

        <h2 className="text-5xl md:text-6xl font-light mb-8 leading-tight">
          On y est... et <span className="italic text-gold-300">on s'amuse !</span>
        </h2>

        <p className="text-lg md:text-xl font-light leading-relaxed text-cream-100/90 max-w-2xl mx-auto mb-6">
          En ce moment même, notre aventure bat son plein. Entre rires, couchers de soleil
          et moments inoubliables, chaque instant est une pure célébration de la liberté.
        </p>

        <div className="flex items-center justify-center gap-3 text-gold-200">
          <Heart className="w-5 h-5 fill-gold-300 text-gold-300" />
          <p className="text-lg md:text-xl italic font-light">
            Un immense merci à toutes celles qui vivent cette expérience avec moi. 💛
          </p>
        </div>
      </div>
    </section>
  );
};

export default VoyageEnCours;
